module.exports = __webpack_public_path__ + "static/media/social-telegram.23eed863.svg";